// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"ok_a bhb_px bhb_a bhb_w","FaqAskQuestion__outdated":"ok_b bhb_ul bhb_vz"};